import React from 'react';

// components
import { YesNo, Select } from '../components/inputs';
import { FormRow } from '../components/layout';

function Miscellaneous() {
  return (
    <div>
      <FormRow showIfFieldExists="veteran">
        <YesNo name="veteran" />
      </FormRow>
      <FormRow showIfFieldExists="chronic_condition">
        <YesNo name="chronic_condition" />
      </FormRow>
      <FormRow showIfFieldExists="veteran_options">
        <Select
          cols="6"
          name="veteran_options"
        />
      </FormRow>
      <FormRow showIfFieldExists="lead_source">
        <Select
          cols="6"
          name="lead_source"
        />
      </FormRow>
    </div>
  );
}

export default Miscellaneous;
